module.exports = __webpack_public_path__ + "static/bg01-9fbbad5f16bc4b85eaf75f2fbbbd9be6.webp";